import { usePageStore } from './page'

export const useSidebarStore = defineStore('sidebar', {
  state: () => {
    return {
      activeSidebar: '',
      activeSidebarExtraProperties: {},
    }
  },
  getters: () => {
    return { activeSidebar: this.activeSidebar }
  },
  actions: {
    toggleCountrySelector() {
      this.activeSidebar = this.activeSidebar ? '' : 'country-selector'
    },
    setActiveSidebar(slug, extraProperties) {
      this.activeSidebar = slug
      this.activeSidebarExtraProperties = extraProperties
      usePageStore().toggleBlockBodyScroll(!!slug)
    },
    closeSidebar() {
      this.activeSidebar = ''
      this.activeSidebarExtraProperties = {}
      usePageStore().toggleBlockBodyScroll(false)
    },
  },
})
